import { Controller } from "stimulus";

const FAQ_LIMIT = 5;

export default class extends Controller {
  static targets = ["panel", "navItem"];

  switchCategory(event) {
    const index = parseInt(event.currentTarget.dataset.categoryIndex);

    this.navItemTargets.forEach((item, i) => {
      item.classList.toggle("faq-accordion__nav-item--active", i === index);
    });

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("faq-accordion__panel--active", i === index);
      if (i === index) {
        this._resetPanel(panel);
      }
    });
  }

  toggle(event) {
    const item = event.currentTarget.closest(".faq-accordion__item");
    item.classList.toggle("faq-accordion__item--open");
  }

  showAll(event) {
    const panel = event.currentTarget.closest(".faq-accordion__panel");
    panel.querySelectorAll(".faq-accordion__item--hidden").forEach((item) => {
      item.classList.remove("faq-accordion__item--hidden");
    });
    event.currentTarget.classList.add("faq-accordion__see-all--hidden");
  }

  _resetPanel(panel) {
    const items = panel.querySelectorAll(".faq-accordion__item");
    items.forEach((item, i) => {
      item.classList.toggle("faq-accordion__item--hidden", i >= FAQ_LIMIT);
    });

    const seeAll = panel.querySelector(".faq-accordion__see-all");
    if (seeAll) {
      seeAll.classList.remove("faq-accordion__see-all--hidden");
    }
  }
}
